import theme from './globalTheme';
export const token = {
  colorPrimary: theme.colors.primary[50],
  fontFamily: 'DB Heavent, sans-serif',
  fontSize: 24
};